module.exports = __webpack_public_path__ + "media/images/my_apps/feature_icons/icon_heart_blue-7683c328f9fad7a1d3529fef3c046d41.svg";